export default __webpack_public_path__ + "static/media/valentinesMob.aad869db.png";